import { FieldSizes } from './shared';
/**
 * Styles override for the Fluent `Dropdown` component.
 */
export const dropdownStyles = theme => ({
    root: {
        maxWidth: FieldSizes.short,
        width: '100%',
    },
    // dropdownItem: {
    //   color: theme.semanticColors.menuItemText,
    // },
    // dropdownItemDisabled: {
    //   color: theme.semanticColors.disabledText,
    // },
    // title: {
    //   color: theme.semanticColors.menuItemText,
    // },
});
